import React, { useContext, useEffect, useState } from "react";
import AdminContext from '../../../StateContext/Application'
import { useNavigate } from 'react-router-dom'
import { Form, Link } from 'react-router-dom'
import { apiurl } from '../../../../../path'
import { saveAs } from 'file-saver';
const TenderWinnerRefund = () => {
    const data = useContext(AdminContext)
    const [tenderWinner, setTenderWinner] = useState([]);
    const { EcsRefund, WinnerRefund, CreateToken, GenerateRefund } = data
    const [hide, sethide] = useState(true)
    const [Message, setMessage] = useState("");
    const [WinnerDatainf, SetWinnerData] = useState({});
    const [searchdata, SetSearchData] = useState([])
    const [GenerateToken, SetGenerateToken] = useState(false)
    const [EToken, SetEToken] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = tenderWinner.slice(indexOfFirstItem, indexOfLastItem);
    const [winnerDetails, setWinnerDetails] = useState([]);
    const [csvdata, setcsvdata] = useState()
    var csv = [["key", "refund_amount", "phone", "email", "Account_Number", "IFSC_CODE", "BANK_NAME", "Account_HolderName", "PANCARD", "GSTNO", "TXNID"]]

    const Navigate = useNavigate();

    useEffect(() => {
        WinnerData();
    }, [])
    console.log("WinnerDatainf", WinnerDatainf);

    async function getlist(id) {
        try {
            let d = await GenerateRefund("Getwinnerbyid", id);
            console.log("d", d);

            setWinnerDetails(d); // Store the data
            csv.push([d[0]?.Regiterationid, d[0]?.ErnestMoneyDeposit, d[0]?.Mobile_No, d[0]?.Email, d[0]?.Account_Number, d[0]?.IFSC_CODE, d[0]?.BANK_NAME, d[0]?.Account_HolderName, d[0]?.PAN_No, d[0]?.GST_No, d[0]?.easepayid]);
            setcsvdata(csv);
        } catch (error) {
            console.error('Error getting list:', error);
        }
    }

    const upload = new FormData();
    const Savefile = async () => {
        try {
            const textToSave = csvdata?.map((item) => Object.values(item).join('|')).join('\n');
            const blob = new Blob([textToSave], { type: 'text/plain;charset=utf-8' });
            upload.append('EcsUpload', blob, 'data.txt');
            saveAs(blob, 'data.txt');
        } catch (error) {
            console.error('Error saving file:', error);
        }
    }





    const Search = async (e) => {
        try {
            let searchvalue = e.currentTarget.value.toLowerCase()
            if (!searchvalue) {
                setTenderWinner(searchdata); // If search value is empty, show all data
                return;
            }
            let data = tenderWinner.filter((x) => {
                return (
                    x.Tender_Name.toLowerCase().includes(searchvalue) ||
                    x.PO_Number.toLowerCase().includes(searchvalue)
                )
            })
            setTenderWinner(data)
        } catch (error) {
            console.error('Error searching:', error);
        }
    }

    const WinnerData = async () => {
        try {
            let d = await EcsRefund()
            setTenderWinner(d)
            SetSearchData(d)
        } catch (error) {
            console.error('Error fetching winner data:', error);
        }
    }
    const form = new FormData();

    async function fileupload(e) {
        console.log(e);
        try {
            form.append("WinnerDocument", e[0])
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    }

    async function handlesubmit(e) {
        try {
            e.preventDefault()
            const form = new FormData();
            form.append("Message", Message)
            form.append("Data", JSON.stringify(WinnerDatainf))
            
            const textToSave = csvdata.map((item) => Object.values(item).join('|')).join('\n');
            form.append("csvdata", JSON.stringify(csvdata))
            form.append("textToSave",textToSave)
            let file = document.getElementById('winnerDocument').files
            console.log(file[0]);
            form.append("WinnerDocument", file[0])
            let data = await WinnerRefund(form,EToken)
            if (data.success==true) {
                alert(data.message);
                window.location.reload()
            }
            else {
                alert(data.message)
                window.location.reload()
            }
        } catch (error) {
            console.error('Error submitting:', error);
        }
    }

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    async function GenerateTokenFor(e) {
        e.preventDefault();
        let data = await CreateToken('Winner_Refund');
        document.getElementById('tokencopys').innerText = data
        SetEToken(data)
        SetGenerateToken(true)
    }
    return (
        <div style={{ display: 'grid', justifyContent: 'center', width: '100%', backgroundColor: '#f6f8fc' }}>


            <div style={{ display: 'flex', flexWrap: 'wrap' }}  >
                <div className='my-3 mx-3 form-control' style={{ textAlign: 'center', padding: '1rem 5rem 0 5rem', backgroundColor: 'white', height: '7rem', width: '80vw' }}>
                    <label><b>Scheme Winner Refund</b></label>
                    <input type='search' className='form-control my-2' onChange={(e) => Search(e)} placeholder='Search by Name/PO Number' style={{ border: "1px solid orange" }}></input>
                </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
                {currentItems.map((auction) => (
                    <>
                        <div className="card my-3 mx-3 form-control" >
                            <div className="row g-0">
                                <div className="col-md-5" style={{ display: 'flex' }}>
                                    <span >
                                        <img style={{ padding: "0", height: "100%", width: '6rem', borderRadius: "6rem" }} src={auction.Tender_Picture ? `${apiurl}/AuctionDetailsget/${auction.Tender_Picture}` : "https://www.the-sustainable-fashion-collective.com/img/http/assets.the-sustainable-fashion-collective.com/assets/the-swatch-book/2014/11/cotton.png/7c098280951a28c0f2aa4291f179ae42.png"} className="" alt="..." />
                                    </span>
                                    <span>
                                        <h5 className="mx-5">{auction.Tender_Name}</h5>
                                        <p className="card-text mx-5"><b>({auction.Tender_ID})</b></p>
                                        <p className="card-text mx-5"><b>Winner Of Scheme({auction.TenderWinnerName})</b></p>
                                    </span>
                                </div>
                                <div className="col my-4 d-flex">
                                    <div>  <button className="btn btn-primary" style={{ backgroundColor: "rgb(10, 200, 150) ", border: "none", borderRadius: "10px" }} onClick={() => { SetWinnerData(auction); sethide(!hide); getlist(auction?.Tender_ID) }}>Generate Winner Refund</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </>
                ))}
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <ul className="pagination">
                        {Array(Math.ceil(tenderWinner.length / itemsPerPage))
                            .fill()
                            .map((_, index) => (
                                <li key={index} className="page-item">
                                    <button onClick={() => paginate(index + 1)} className="page-link">
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                    </ul>
                </div>


                <div className="card" style={{ width: '100%', height: "100%", position: "absolute", left: "0", bottom: "0", borderRadius: "20px" }} hidden={hide}>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Refund_Status</th>
                                <th scope="col">Regiterationid</th>
                                <th scope="col">Bidder_CompanyName</th>
                                <th scope="col">Refund Amount</th>
                                <th scope="col">GST_No</th>
                                <th scope="col">PAN_No</th>
                                <th scope="col">WinningStatus</th>
                                <th scope="col">Scheme_Name</th>

                            </tr>
                        </thead>
                        <tbody>

                            {winnerDetails.map((e, index) => (
                                <tr key={index}>
                                    <td className={e.Refund_Status === 'No Refund' ? 'text-bg-danger' : 'text-bg-warning'}>Refund</td>
                                    <td>{e.Regiterationid}</td>
                                    <td>{e.Bidder_CompanyName}</td>
                                    <td>{e.ErnestMoneyDeposit}</td>
                                    <td>{e.GST_No}</td>
                                    <td>{e.PAN_No}</td>
                                    <td className={e.WinningStatus === 'Tender Winner' ? 'text-bg-success' : 'text-bg-danger'}>{e.WinningStatus}</td>
                                    <td>{e.Tender_Name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button
                        className="btn btn-primary"
                        onClick={Savefile}
                        style={{ margin: '10px', backgroundColor: 'green', border: 'none', borderRadius: '10px' }}
                    >
                        Download Data
                    </button>
                    <div className="card-body">
                        <h5 className="card-title">Generate Token</h5>
                        <textarea className="form-control" id='tokencopys' value={EToken}></textarea>
                        <button hidden={GenerateToken} className='btn btn-success my-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
                    </div>
                    <div className="card-body" hidden={!GenerateToken}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <h6>Send Message</h6>
                            <button className="btn btn-close mb-3 mx-3" aria-label="close" style={{ padding: "10px", backgroundColor: "#f6f8fc", border: "2px", width: "1rem", height: "1rem", borderRadius: "20px" }} onClick={(x) => sethide(true)}></button>
                        </div>
                        <textarea id='message' className='form-control my-3' onChange={(e) => { setMessage(e.target.value) }}></textarea>
                        <input type="file" className="form-control my-2" id='winnerDocument' onChange={(e) => { fileupload(e.currentTarget.files) }}></input>
                        <hr></hr>
                        <button className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={(x) => handlesubmit(x)}>Submit</button>
                        <button className='btn btn-danger' style={{ backgroundColor: "#e73d26", border: "none", borderRadius: "10px" }} onClick={(x) => sethide(true)}>close</button>
                    </div>

                </div>
            </div>

        </div>
    )
}
export default TenderWinnerRefund;